<template>
  <div class="switch">
    <div class="buttons">
      <ul v-if = existFreepass
          class="buttons buttons-deco"
      >
        <li
          v-bind:class="{ active2: isSelect===optionInfo }"
          @click="changeList(optionInfo)"
          class="button2"
        >
          お知らせ
        </li>
        <li
          v-bind:class="{ active2: isSelect===optionTips }"
          @click="changeList(optionTips)"
          class="button2 border"
          style="border-right: none"
        >
          豆知識
        </li>
        <li
          v-if = existFreepass
          v-bind:class="{ active2: isSelect===optionFreepass }"
          @click="changeList(optionFreepass)"
          class="button2 border"
        >
          フリーパス
        </li>
        <li
          v-bind:class="{ active2: isSelect===optionCoupon }"
          @click="changeList(optionCoupon)"
          class="button2"
        >
          クーポン
        </li>
      </ul>
    </div>
    <div v-if = !existFreepass class="buttons">
      <ul class="buttons-deco">
        <li
          v-bind:class="{ active1: isSelect===optionInfo }"
          @click="changeList(optionInfo)"
          class="button1"
        >
          お知らせ
        </li>
        <li
          v-bind:class="{ active1: isSelect===optionTips }"
          @click="changeList(optionTips)"
          class="button1 border"
        >
          豆知識
        </li>
        <li
          v-bind:class="{ active1: isSelect===optionCoupon }"
          @click="changeList(optionCoupon)"
          class="button1"
        >
          クーポン
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopMenu',
  props: {
    select: { type: String },
    freepass: { type: Boolean }
  },
  data: function() {
    return {
      optionInfo: 'お知らせ',
      optionTips: '豆知識',
      optionFreepass: 'フリーパス',
      optionCoupon: 'クーポン',
      isSelect: 'クーポン',
      existFreepass: false
    }
  },
  async created() {
    this.existFreepass = this.freepass
    this.isSelect = this.select
  },
  methods: {
    changeList: function(isSelect) {
      this.isSelect = isSelect
      this.$emit('click', isSelect)
    }
  }
}
</script>

<style scoped lang="scss">
.border {
  border-left: 1px solid #C0A417;
  border-right: 1px solid #C0A417;
}
.switch {
  display: block;
  text-align: center;
  padding: 15px 0;

  .buttons {
    margin-left: 14px;
    margin-right: 14px;

    .buttons-deco {
      margin: 0 auto;
      overflow: hidden;
      border: 1px solid #C0A417;
      background-color: white;
      border-radius: 5px;
      color: #592711;
      font-size: 12px;
      font-weight: bold;
    }

    .button1 {
      display: inline-block;
      width: calc(100% / 3);
      text-align: center;
      padding: 6px 0;
    }
    .button2 {
      display: inline-block;
      width: calc(100% / 4);
      text-align: center;
      padding: 6px 0;
    }
    .active1 {
      background-image: url("~@/assets/img/premium/tab_on.png");
      width: calc(100% / 3);
      height:auto;
      background-size:cover;
      background-position:center;
      color: white;
    }
    .active2 {
      background-image: url("~@/assets/img/premium/tab_on.png");
      width: calc(100% / 4);
      height:auto;
      background-size:cover;
      background-position:center;
      color: white;
    }
  }
}
</style>
